export default "__VITE_ASSET__30b03e72__"